/**
 * Format a duration at the precision it is received: H:MM for whole minutes, H:MM:SS when the value carries seconds.
 * Milliseconds are rounded to the nearest second so the rows add up to the server total
 */
export function formatDurationExact(durationMs: number): string {
  const negative = durationMs < 0;
  const totalSeconds = Math.round(Math.abs(durationMs || 0) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const formatted = hours + ':' + String(minutes).padStart(2, '0') + (seconds ? ':' + String(seconds).padStart(2, '0') : '');
  return negative ? '-' + formatted : formatted;
}
